import React from 'react';
import DataTableWrapper from '../DataTableWrapper';

const JananiDataTable = ({ records, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage }) => {
    return (
        <DataTableWrapper
            loading={loading} currentPage={currentPage} setCurrentPage={setCurrentPage}
            totalCount={totalCount} totalPages={totalPages} rowsPerPage={rowsPerPage}
        >
            <table className="table table-striped table-hover table-bordered align-middle text-center mb-0" style={{ fontSize: 13 }}>
                        <thead>
                            <tr>
                                <th rowSpan={3}>Sr. No.</th>
                                <th rowSpan={3}>Reporting Date</th>
                                <th rowSpan={3}>State Name</th>
                                <th rowSpan={3} className="section-divider">District Name</th>
                                
                                <th colSpan={4} className="cohort-header-preg section-divider">Pregnancy</th>
                                <th colSpan={4} className="cohort-header-children section-divider">Severe anemia treatment (ANC)</th>
                                <th colSpan={4} className="cohort-header-adolescents section-divider">No. of IFA tabs given (ANC)</th>
                                <th colSpan={4} className="cohort-header-lactating section-divider">Lactating Women (0-6 months)</th>
                                <th colSpan={4} className="cohort-header-senior">No. of IFA tabs given (PNC)</th>
                            </tr>
                            <tr>
                                {/* Pregnancy */}
                                <th className="cohort-preg">Non Anaemic</th>
                                <th className="cohort-preg">Mild</th>
                                <th className="cohort-preg">Moderate</th>
                                <th className="cohort-preg section-divider">Severe</th>

                                {/* Severe Anaemia treatment (ANC) */}
                                <th className="cohort-children">Iron Supplements</th>
                                <th className="cohort-children">Iron Sucrose Injection</th>
                                <th className="cohort-children">Blood Transfusion</th>
                                <th className="cohort-children section-divider">Not Medically Treated</th>

                                {/* IFA tabs given (ANC) */}
                                <th className="cohort-adolescents">Non Anaemic</th>
                                <th className="cohort-adolescents">Mild</th>
                                <th className="cohort-adolescents">Moderate</th>
                                <th className="cohort-adolescents section-divider">Severe</th>

                                {/* Lactating Women */}
                                <th className="cohort-lactating">Non Anaemic</th>
                                <th className="cohort-lactating">Mild</th>
                                <th className="cohort-lactating">Moderate</th>
                                <th className="cohort-lactating section-divider">Severe</th>

                                {/* IFA tabs given (PNC) */}
                                <th className="cohort-senior">Non Anaemic</th>
                                <th className="cohort-senior">Mild</th>
                                <th className="cohort-senior">Moderate</th>
                                <th className="cohort-senior">Severe</th>
                            </tr>
                            <tr className="text-center align-middle sub-header-ranges">
                                <th className="cohort-preg" style={{ fontSize: 10 }}>&gt; 11 g/dl</th>
                                <th className="cohort-preg" style={{ fontSize: 10 }}>10–10.9 g/dl</th>
                                <th className="cohort-preg" style={{ fontSize: 10 }}>7-9.9 g/dl</th>
                                <th className="cohort-preg section-divider" style={{ fontSize: 10 }}>&lt; 7 g/dl</th>

                                <th className="cohort-children" style={{ fontSize: 10 }}></th>
                                <th className="cohort-children" style={{ fontSize: 10 }}></th>
                                <th className="cohort-children" style={{ fontSize: 10 }}></th>
                                <th className="cohort-children section-divider" style={{ fontSize: 10 }}></th>

                                <th className="cohort-adolescents" style={{ fontSize: 10 }}></th>
                                <th className="cohort-adolescents" style={{ fontSize: 10 }}></th>
                                <th className="cohort-adolescents" style={{ fontSize: 10 }}></th>
                                <th className="cohort-adolescents section-divider" style={{ fontSize: 10 }}></th>

                                <th className="cohort-lactating" style={{ fontSize: 10 }}>&gt; 12 g/dl</th>
                                <th className="cohort-lactating" style={{ fontSize: 10 }}>11–11.9 g/dl</th>
                                <th className="cohort-lactating" style={{ fontSize: 10 }}>8-10.9 g/dl</th>
                                <th className="cohort-lactating section-divider" style={{ fontSize: 10 }}>&lt; 8 g/dl</th>

                                <th className="cohort-senior" style={{ fontSize: 10 }}></th>
                                <th className="cohort-senior" style={{ fontSize: 10 }}></th>
                                <th className="cohort-senior" style={{ fontSize: 10 }}></th>
                                <th className="cohort-senior" style={{ fontSize: 10 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((r, idx) => (
                                <tr key={r.id || idx}>
                                    <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                                    <td>{r.report_date}</td>
                                    <td>{r.state_name}</td>
                                    <td className="section-divider"><strong className="text-body">{r.district_name}</strong></td>

                                    {/* Pregnancy */}
                                    <td className="cohort-preg">{r.preg_non_anaemic || 0}</td>
                                    <td className="cohort-preg">{r.preg_mild || 0}</td>
                                    <td className="cohort-preg">{r.preg_moderate || 0}</td>
                                    <td className="cohort-preg color-severe section-divider">{r.preg_severe || 0}</td>

                                    {/* Severe Treatment */}
                                    <td className="cohort-children">{r.sev_anc_iron_supplements || 0}</td>
                                    <td className="cohort-children">{r.sev_anc_iron_sucrose_inj || 0}</td>
                                    <td className="cohort-children">{r.sev_anc_blood_transfusion || 0}</td>
                                    <td className="cohort-children color-severe section-divider">{r.sev_anc_not_treated || 0}</td>

                                    {/* IFA ANC */}
                                    <td className="cohort-adolescents">{r.ifa_anc_non_anaemic || 0}</td>
                                    <td className="cohort-adolescents">{r.ifa_anc_mild || 0}</td>
                                    <td className="cohort-adolescents">{r.ifa_anc_moderate || 0}</td>
                                    <td className="cohort-adolescents color-severe section-divider">{r.ifa_anc_severe || 0}</td>

                                    {/* Lactating */}
                                    <td className="cohort-lactating">{r.lactating_non_anaemic || 0}</td>
                                    <td className="cohort-lactating">{r.lactating_mild || 0}</td>
                                    <td className="cohort-lactating">{r.lactating_moderate || 0}</td>
                                    <td className="cohort-lactating color-severe section-divider">{r.lactating_severe || 0}</td>

                                    {/* IFA PNC */}
                                    <td className="cohort-senior">{r.ifa_pnc_non_anaemic || 0}</td>
                                    <td className="cohort-senior">{r.ifa_pnc_mild || 0}</td>
                                    <td className="cohort-senior">{r.ifa_pnc_moderate || 0}</td>
                                    <td className="cohort-senior color-severe">{r.ifa_pnc_severe || 0}</td>
                                </tr>
                            ))}
                            {records.length === 0 && (
                                <tr>
                                    <td colSpan={24} className="text-center py-4 text-muted">
                                        No records match the current filters.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
        </DataTableWrapper>
    );
};

export default JananiDataTable;
